import React, { useMemo } from "react";

import { SingleSelectInput } from "@performyard/py-components";

import { useGroupsInternalApi } from "../../../api/hooks";

import type { Group } from "../../../api/services/defs/groups";

export type { Group } from "../../../api/services/defs/groups";

type GroupSelectProps = {
	value?: string | Group;
	onChange: (value: Group | null) => void;
	placeholder?: string;
	isClearable?: boolean;
	disabled?: boolean;
	hasEmployees?: boolean;
};

const GroupSelect = ({
	value,
	onChange,
	placeholder = "Make a selection",
	isClearable = false,
	disabled = false,
	hasEmployees,
}: GroupSelectProps) => {
	const { data: groups, isLoading } = useGroupsInternalApi(hasEmployees !== undefined ? { hasEmployees } : undefined);

	const selectOptions = useMemo(
		() =>
			(groups ?? []).map((group) => ({
				label: group.name,
				value: group,
			})),
		[groups]
	);

	const resolvedValue = useMemo(() => {
		if (!value) return undefined;
		if (typeof value === "string") return groups?.find((g) => g.id === value);
		return groups?.find((g) => g.id === value.id) ?? value;
	}, [value, groups]);

	return (
		<SingleSelectInput<Group>
			options={selectOptions}
			value={resolvedValue}
			onChange={onChange}
			placeholder={isLoading ? "Loading..." : placeholder}
			isClearable={isClearable}
			disabled={disabled || isLoading}
			selectionVariant="combobox"
		/>
	);
};

export default GroupSelect;
